import { Component, ViewChild } from '@angular/core';
import { App, NavController, NavParams, Slides, Tabs } from 'ionic-angular';
import { WpProvider } from '../../providers/wp/wp';
import { SubmenuPage } from '../submenu/submenu';
import { InAppBrowser, InAppBrowserObject } from '@ionic-native/in-app-browser';
import { PhcLinkServiceProvider } from '../../providers/phc-link-service/phc-link-service';
import { PhcApp, PhcAppTab, PhcLink } from '../../classes/phc-app/phc-app';
import { WebpageIframePage } from '../webpage-iframe/webpage-iframe';
import { GalleryPage } from '../gallery/gallery';
import { ModuleLinkProvider } from '../../providers/module-link/module-link';
import { CameraPage } from '../camera/camera';
import { take } from 'rxjs/operators';
import { TabUpdateProvider } from '../../providers/tab-update/tab-update.service';


import { find } from 'lodash';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { KioskServiceProvider } from '../../providers/kiosk-service/kiosk-service';


interface ITab {
  root: any;
  title: string;
  icon: string;
  rootParams: any;
  link: PhcLink;
  phcTab: PhcAppTab;
}

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {

  @ViewChild('appTabs') appTabs: Tabs;
  phcApp: PhcApp;
  homeTabRoot = SubmenuPage;
  homeTabParams;
  cameraTabRoot = CameraPage;
  browser: InAppBrowserObject;
  tabs: ITab[] = [];
  homePage = true;

  constructor(public navCtrl: NavController,
              private wp: WpProvider,
              private iab: InAppBrowser,
              private linkService: PhcLinkServiceProvider,
              public app: App,
              private moduleLink: ModuleLinkProvider,
              private tabUpdate: TabUpdateProvider,
              private analytics: AnalyticsProvider, private kiosk: KioskServiceProvider, private navParams: NavParams) {
    this.phcApp = this.wp.app;
    this.homeTabParams = {menuId: this.phcApp.home_menu.id, homePage: true };
      setTimeout(() => {
        if (this.phcApp && this.phcApp.tabs) {
          this.tabs = this.phcApp.tabs.map(t => {
            const tab: ITab = {
              root: null,
              rootParams: <any>{},
              title: t.name,
              icon: t.icon,
              link: t.link,
              phcTab: t,
            };
            const r = this.rootFromTab(t);
            if (r) {
              tab.root = r.root;
              tab.rootParams = r.rootParams;
            }
            return tab;
          });
        }
      }, 0);

      this.tabUpdate.moduleUpdates.subscribe(newModule => {
        const planadayTab = find(this.tabs, { link : { moduleId: 2021 } });
        const index = this.tabs.indexOf(planadayTab) + 1;
        this.appTabs.select(index);
      });

      this.tabUpdate.tabUpdates.subscribe((nextTabInd: number) => {
        console.log('Tab', nextTabInd);
        this.appTabs.select(nextTabInd);
      });

    this.kiosk.appActivity.subscribe(() => {console.log('activity'); this.resetSlideshow();});

  }

  rootFromTab(tab: PhcAppTab): { root: any, rootParams: any }|null {
    if (tab.link.isMenu()) {
      return {
        root: SubmenuPage,
        rootParams: { menuId: tab.link.menuId }
      }
    } else if (tab.link.isGallery()) {
      return {
        root: GalleryPage,
        rootParams: { galleryId: tab.link.galleryId }
      }
    } else if(tab.link.isModule()) {
      return {
        root: this.moduleLink.getModule(this.phcApp.getModule(tab.link.moduleId).moduleKey),
        rootParams: { module: tab.link.module }

      }
    } else if (tab.link.isWebpage() && tab.link.webpageTarget === 'iframe') {
      return {
        root: WebpageIframePage,
        rootParams: { url: tab.link.webpageUrl }
      }
    }
    return null;
  }

  onTabSelected(event) {
    const tab: ITab = this.tabs[event.index - 1];
    if (!this.rootFromTab(tab.phcTab)) {
      this.linkService.activateLink(tab.link);
    }
    this.kiosk.startSliders.next(true);
  }

  ionViewDidLoad(){ }

  showSlideshow = true;
  slideshowTimeout;
  slideshowTimeoutDelay = 120000;

  get slideshowEnabled() {
    return this.kiosk.isKiosk && this.showSlideshow;
  }

  resetSlideshow() {
    console.log('resetting');
    this.showSlideshow = false;
    clearTimeout(this.slideshowTimeout);
    this.slideshowTimeout = setTimeout(() => {
      this.showSlideshow = true;
    }, this.slideshowTimeoutDelay);
  }

  slideshowInterval;

  cycleSlideshow(slides: Slides) {
    slides.stopAutoplay();
    clearInterval(this.slideshowInterval);
    this.slideshowInterval = setInterval(() => {
      slides.slideNext();
    }, 8000);
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts